import { ReactNode, useCallback, useContext, useEffect, useRef, useState } from 'react';
import { Box, Paper, TableContainer, Unstable_Grid2 as Grid, Table, TableHead, TableRow, TableCell, CardHeader, Card, CardContent, TableBody, Select, FormControl, Checkbox, InputLabel, ListItemText, MenuItem, Autocomplete, TextField, Avatar, List, ListItem, ListItemAvatar, ListItemButton, Button, IconButton, Alert, ListItemIcon, FormControlLabel } from "@mui/material";
import { BojDataOutout, BojGroup, DataOutput, DropdownModel } from '../../data/interfaces/sharedmodels';
import DataTableHeader from '../childcomponents/datatableheader';
import { Add, ContentCopy, ContentPaste, CopyAll, Delete, Train as TrainIcon } from '@mui/icons-material';
import magneticService from '../../data/api/magnetic.service';
import { useAppDispatch, useAppSelector } from '../../stores/hooks';
import { showerrormessage, showsuccessmessage, showwarningmessage } from '../../stores/notificationslice';
import ConfirmDialog from '../confirmdialog';
import { MenuProps } from "../commonprops";
import { Tooltip } from '@mui/material';
import { IsEditedContext } from '../../../App';

const GroupList = ({ data, callback }: { data: BojDataOutout, callback: any }) => {
    const [currentData, setCurrentData] = useState<BojDataOutout>(data);
    const [selectedGroup, setSelectedGroup] = useState(0);
    const [canAddNlc, setCanAddNlc] = useState(false);
    const [selectedNlc, setSelectedNlc] = useState<DropdownModel | null>(null);
    const autoC = useRef<HTMLButtonElement>(null);
    const [nlcNotFound, setNlcNotFound] = useState(false);
    const [checkedNlcs, setCheckedNlcs] = useState(new Set<string>());
    const datatbleexpanded = useAppSelector((state) => state.magneticReducer.datatableExpanded);
    const dispatch = useAppDispatch();
    useEffect(() => {
        setCurrentData(data);
    }, [data]);

    useEffect(() => {
        setCheckedNlcs(prevCheckedNlcs => {
            const newCheckedNlcs = new Set(prevCheckedNlcs);
            newCheckedNlcs.clear();
            return newCheckedNlcs;
        });
    }, [selectedGroup])
    const addNlc = () => {
        if (selectedNlc && selectedGroup > -1) {
            var existing= currentData.BojGroups.find(b =>  b.Nlc == selectedNlc.Id);
            if(existing&&existing.Nlc)
            {
                dispatch(showwarningmessage(`NLC ${selectedNlc.Id} exists in the group ${existing.BojGroup}.`));
                return;
            }
            let tempdata = { ...currentData }
            tempdata.BojGroups.push({ Id: 0, Nlc: selectedNlc.Id, BojGroup: selectedGroup, Version: currentData.Version, BwdCompatVersion: null });
            callback(tempdata.BojGroups);
            //setCurrentData(tempdata);
            if (autoC.current) {
                const ele = autoC.current.getElementsByClassName('MuiAutocomplete-clearIndicator')[0];
                if (ele) (ele as HTMLButtonElement).click();
            }

        }
    }
    const removeNlc = (nlc: DropdownModel) => {
        let tempdata = { ...currentData }
        tempdata.BojGroups.splice(data.BojGroups.findIndex(a => a.Nlc == nlc.Id && a.BojGroup == selectedGroup), 1);
        //setCurrentData(tempdata);
        callback(tempdata.BojGroups);
    }

    const handleAutocompleteChange = (event: any, value: DropdownModel | null) => {
        if (value) {
            setSelectedNlc(value);
            setCanAddNlc(true);
            const groupContainingNlc = currentData.BojGroups.find(group => group.Nlc === value.Id);
            if (groupContainingNlc) {
                setSelectedGroup(groupContainingNlc.BojGroup);
                setNlcNotFound(false);
            } else {
                setNlcNotFound(true);
            }
        } else {
            setCanAddNlc(false);
            setSelectedNlc(null);
            setNlcNotFound(false);
        }
    };

    const onCopy = (all: boolean) => {
        var nlcstoCopy;
        if (all) {
            nlcstoCopy = currentData.Nlcs.filter(a => currentData.BojGroups.filter(b => b.BojGroup == selectedGroup).flatMap(g => g.Nlc).findIndex(f => f == a.Id) > -1);
        }
        else {
            nlcstoCopy = currentData.Nlcs.filter(a => checkedNlcs.has(a.Id));
        }
        navigator.clipboard.writeText(nlcstoCopy?.flatMap(a => a.Id).join('\n') ?? "")
            .then(() => dispatch(showsuccessmessage('NLC(s) copied to clipboard successfully.')))
            .catch(err =>dispatch(showerrormessage('"Failed to copy items to clipboard.')) );
    }


    const pasteFromClipboard = () => {
        try {
            navigator.clipboard.readText()
                .then((text) => {
                    let tempdata = { ...currentData }
                    let totalCount=0;
                    let pasetCount=0;
                    text.split("\n").forEach(nlc => {
                        let nlcValue = nlc.replace('\r', '');
                        totalCount++;
                        if (currentData.BojGroups.findIndex(b =>  b.Nlc == nlcValue) < 0){
                            tempdata.BojGroups.push({ Id: 0, Nlc: nlcValue, BojGroup: selectedGroup, Version: currentData.Version, BwdCompatVersion: null });
                            pasetCount++;
                        }
                        });
                    callback(tempdata.BojGroups);
                    dispatch(showsuccessmessage(`${pasetCount} of ${totalCount} NLC(s) copied from clipboard successfully.`));
                })


        } catch (err) {
            dispatch(showerrormessage('"Failed to read items to clipboard.'))
        }
    };

    const onNlcCheckChange = (nlcId: string, checked: boolean) => {
        setCheckedNlcs(prevCheckedNlcs => {
            const newCheckedNlcs = new Set(prevCheckedNlcs);
            if (checked) {
                newCheckedNlcs.add(nlcId);
            } else {
                newCheckedNlcs.delete(nlcId);
            }

            return newCheckedNlcs;
        });
    }

    return (
        <Box component={Paper} sx={{ p: 1 }}>


            <FormControl fullWidth >
                <InputLabel>Group</InputLabel>
                <Select
                    size="small"
                    label="Group"
                    className="smallpadding"
                    sx={{ m: 0 }}
                    value={selectedGroup}
                    onChange={(event: any) => {
                        setSelectedGroup(event.target.value);
                    }}
                    MenuProps={MenuProps}
                >
                    {currentData.OriginGroups.map((item) => (
                        <MenuItem key={'group' + item} value={item}>
                            <ListItemText primary={item} />
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>


            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <FormControl fullWidth sx={{ mr: 1 }}>
                    <Autocomplete
                        ref={autoC}
                        size="small"
                        disablePortal
                        disabled={!currentData.IsEditable}
                        id="nlc-search"
                        options={currentData.Nlcs}
                        getOptionLabel={(option) => `${option.Id}-${option.Description}`}
                        onChange={handleAutocompleteChange}
                        renderInput={(params) => <TextField {...params} label="Search NLC" />}
                    />
                </FormControl>

                <IconButton
                    disabled={!canAddNlc || !currentData.IsEditable}
                    onClick={addNlc}
                >
                    <Avatar
                        sx={{
                            backgroundColor: 'primary.main',
                            opacity: canAddNlc ? 1 : 0.4,
                            cursor: canAddNlc ? 'pointer' : 'not-allowed',
                        }}
                    >
                        <Add />
                    </Avatar>
                </IconButton>
            </Box >
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }} gap={1}>
                {datatbleexpanded ?
                    <>
                        <Button variant='outlined' onClick={() => onCopy(false)}>Copy(selected)</Button>
                        <Button variant='outlined' onClick={() => onCopy(true)}>Copy(All)</Button>
                        <Button variant='outlined' onClick={pasteFromClipboard} >Paste</Button></> :
                    <>
                        <Tooltip title='Copy Selected'><IconButton  onClick={() => onCopy(false)}><ContentCopy sx={{ color: 'primary.main' }} /></IconButton></Tooltip>
                        <Tooltip title='Copy All'><IconButton  onClick={() => onCopy(true)}><CopyAll sx={{ color: 'primary.main' }} /></IconButton></Tooltip>
                        <Tooltip title='Paste from clipboard'><IconButton  onClick={pasteFromClipboard}><ContentPaste sx={{ color: 'primary.main' }} /></IconButton></Tooltip>
                    </>}

            </Box>
            {nlcNotFound && (
                <Alert severity="warning">NLC not found in any group.</Alert>
            )}
            <List disablePadding={true} dense={true} sx={{ height: 878, overflowY: 'scroll' }}>
                {
                    currentData.Nlcs.filter(a => currentData.BojGroups.filter(b => b.BojGroup == selectedGroup).flatMap(g => g.Nlc).findIndex(f => f == a.Id) > -1).map(function (nlc: DropdownModel) {
                        return (
                            <ListItem key={nlc.Id}
                                disablePadding
                                secondaryAction={currentData.IsEditable ?
                                    <IconButton size="small" edge="end" aria-label="remove item" onClick={(event,) => removeNlc(nlc)}>
                                        <Delete sx={{ color: "primary.main" }} />
                                    </IconButton> : null
                                }
                            >
                                <ListItemButton>
                                    <ListItemIcon sx={{minWidth:0}}>
                                        <Checkbox
                                            size="small"
                                            edge="start"
                                            checked={checkedNlcs.has(nlc.Id)}
                                            tabIndex={-1}
                                            onChange={(e) => onNlcCheckChange(nlc.Id, e.target.checked)}
                                            disableRipple
                                        />
                                    </ListItemIcon>
                                    <ListItemText primary={nlc.Id + '-' + nlc.Description} />
                                </ListItemButton></ListItem>)
                    })
                }
            </List>
        </Box>
    )
}



const BreakOfJourneyTable = ({ data }: { data: BojDataOutout }) => {
    const [currentData, setCurrentData] = useState<BojDataOutout>(data);
    const { setIsEdited } = useContext(IsEditedContext);
    useEffect(() => {
        setCurrentData(data);
    }, [data]);

    const handleCheckChange = (isChecked: boolean, orgGroup: number, destGroup: number) => {
        let tempdata = { ...currentData };
        let index = tempdata.BojItems.findIndex(a => a.Origin_Group == orgGroup && a.Dest_Group == destGroup);

        if (index < 0 && isChecked) {
            tempdata.BojItems.push({ Id: 0, Origin_Group: orgGroup, Dest_Group: destGroup, Operation: 3, Version: currentData.Version, BwdCompatVersion: null });
            tempdata.BojItems.push({ Id: 0, Origin_Group: destGroup, Dest_Group: orgGroup, Operation: 3, Version: currentData.Version, BwdCompatVersion: null });
        }
        else if (index > -1 && !isChecked) {
            tempdata.BojItems.splice(index, 1);
            let index2 = tempdata.BojItems.findIndex(a => a.Origin_Group == destGroup && a.Dest_Group == orgGroup);
            tempdata.BojItems.splice(index2, 1);
        }
        setCurrentData(tempdata);
        setIsEdited(true);
    }

    return (
        <Box component={Paper}>
            <TableContainer>
                <Table size='small'>
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ width: 20, padding: '2px' }}></TableCell>
                            {currentData.OriginGroups.map((group) => (
                                <TableCell key={'head' + group} sx={{ width: 20, padding: '2px', textAlign: 'center' }}>{group}</TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {currentData.DestinationGroups.map((destGroup) => (
                            <TableRow key={'dest' + destGroup}>
                                <TableCell sx={{ width: 20, padding: '5px' }}>{destGroup}</TableCell>
                                {currentData.OriginGroups.map((orgGroup) => (
                                    orgGroup === destGroup ? (
                                        <TableCell key={'org' + orgGroup} sx={{ width: 20, padding: '2px' }}></TableCell>
                                    ) : (
                                        <TableCell key={'org' + orgGroup} sx={{ width: 20, padding: '2px', textAlign: 'center' }}>
                                            <Tooltip title={destGroup + '-' + orgGroup}>
                                                <Checkbox
                                                    disabled={!currentData.IsEditable}
                                                    onChange={(event) => handleCheckChange(event.target.checked, orgGroup, destGroup)}
                                                    size='small'
                                                    className='nopadding'
                                                    checked={currentData.BojItems.findIndex(a => a.Origin_Group == orgGroup && a.Dest_Group == destGroup) > -1}
                                                    sx={{ fontSize: '1.25em', cursor: currentData.IsEditable ? "pointer" : "not-allowed" }}
                                                    color='primary'
                                                />
                                            </Tooltip>
                                        </TableCell>
                                    )
                                ))}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
}


export default function BreakOfJourney({ heading, data, parent, versions, callback }:
    { heading: string | undefined, data: BojDataOutout, parent: string, versions: DropdownModel[], callback: any }) {
    const [currentData, setCurrentData] = useState<BojDataOutout>({ IsEditable: true, ReadOnlyUser: true, Nlcs: [], BojItems: [], OriginGroups: [], DestinationGroups: [], BojGroups: [], TableId: 0, Version: '' });
    const dispatch = useAppDispatch();
    const [dialogOpen, setDialogOpen] = useState<boolean>(false);
    const [dialogTitle, setDialogTitle] = useState<string>('');
    const [dialogMessage, setDialogMessage] = useState<string>('');
    const { setIsEdited } = useContext(IsEditedContext);
    const selectedNlcs = useAppSelector((state) => {
        if (parent === 'magnetic') { return state.magneticReducer.selectedNlcs; }
        else { return state.itsoReducer.selectedNlcs; }
    });
    const selectedVersion = useAppSelector((state) => {
        if (parent === 'magnetic') { return state.magneticReducer.selectedVersion; }
        else { return state.itsoReducer.selectedVersion; }
    });
    const selectedTable = useAppSelector((state) => {
        if (parent === 'magnetic') { return state.magneticReducer.selectedDataTable; }
        else { return state.itsoReducer.selectedDataTable; }
    });

    useEffect(() => {
        //if (data && data.BojGroups) {
        setCurrentData(data);
        //}
    }, [data]);

    const changeBojCallback = useCallback((groups: BojGroup[]) => {
        let tempData = { ...currentData };
        tempData.BojGroups = groups;
        setCurrentData(tempData);
        setIsEdited(true);
    }, [currentData]);

    const handleSave = () => {
        let modifiedData = { ...currentData };
        modifiedData.Version = selectedVersion ?? '';
        const updateInput = { NlcId: selectedNlcs.length > 0 ? selectedNlcs[0].Id : 0, TocId: 1, InputData: modifiedData };
        magneticService.updateBOJData(updateInput).then((response) => {
            if (response && response.data) {
                dispatch(showsuccessmessage("Data updated successfully."));
                setIsEdited(false);
                callback();
            }
        }).catch((response) => {
            dispatch(showerrormessage(response.message));
        })
    }

    const handleSetCurrent = () => {
        setDialogTitle('Set Version');
        setDialogMessage('Confirm change of current version to as ' + selectedVersion + '?');

        setDialogOpen(true);
    }

    const confirmDialogCallback = useCallback((confirmed: boolean, remarks: string, type: string) => {
        setDialogOpen(false);
        if (confirmed) {
            if (type == "Set Version") {
                magneticService.setCurrentVersion(selectedVersion ?? "", selectedTable?.Id ?? 0, remarks, selectedNlcs.length ? selectedNlcs[0].Id : null).then((response) => {
                    if (response.data.IsSuccess) {
                        dispatch(showsuccessmessage(response.data.Message))
                        callback();
                    }
                    else {
                        dispatch(showerrormessage(response.data.Message))
                    }

                });
            }
            else if (type == "Delete") {
                alert('delete');
            }
        }
    }, [selectedTable, selectedVersion])

    return (
        <Card>
            <CardHeader sx={{ p: 1 }} title={<DataTableHeader heading={heading} parent={parent} versions={versions} />} />
            <CardContent>
                {currentData.OriginGroups && currentData.OriginGroups.length > 0 ?
                    <Grid container spacing={2}>
                        <Grid xs={3}>
                            <GroupList data={currentData} callback={changeBojCallback} />
                        </Grid>
                        <Grid xs={9}>
                            <BreakOfJourneyTable data={currentData} />
                        </Grid>
                        <Grid xs={12}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
                                {!currentData.ReadOnlyUser && currentData.Version != selectedVersion ? <Button variant="outlined" onClick={handleSetCurrent}>Set as Current Version</Button> : <div />}
                                {currentData.IsEditable ? <Button variant="contained" onClick={handleSave}>Save</Button> : null}

                            </Box>
                        </Grid>
                    </Grid>
                    : 'No data found for the current selection'}
            </CardContent>
            <ConfirmDialog needComments={true} isopen={dialogOpen} title={dialogTitle} message={dialogMessage} callback={confirmDialogCallback} />
        </Card>
    );
}